import { globalActor } from "../../state/GlobalContextProvider";
import { useSelector } from "@xstate/react";
export default function Header() {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  const showMenu = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showMenu
  );
  const showSidebar = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showSidebar
  );
  let showSectionTitle = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showSectionTitle
  );
  let overrideTitle = useSelector(
    globalActor,
    (snapshot) => snapshot.context.overrideTitle
  );

  let title = null;

  if (state.toLowerCase().match("prime")) {
    title = (
      <>
        <span></span>
        <span>
          PRIMING
          <br /> THE BOTTLE
        </span>
      </>
    );
  }
  if (state.toLowerCase().match("drop")) {
    title = (
      <>
        <span>What to expect</span> <span>DROP SIZE</span>
      </>
    );
  }
  if (state.toLowerCase().match("dropsize1") && overrideTitle !== "DropSize") {
    title = (
      <>
        <span></span>
        <span>
          PRIMING
          <br /> THE BOTTLE
        </span>
      </>
    );
  }
  if (state.toLowerCase().match("blink")) {
    title = (
      <>
        <span>What to expect</span>
        <span>BLINK REFLEX</span>
      </>
    );
  }
  if (
    state.toLowerCase().match("blinkreflex1") &&
    overrideTitle !== "BlinkReflex"
  ) {
    title = (
      <>
        <span>What to expect</span>
        <span>DROP SIZE</span>
      </>
    );
  }

  return (
    <header className={state === "whatPatients" ? "Patients" : ""}>
      <div
        className="Logo"
        onClick={(_) => globalActor.send({ type: "SKIP_TO_START" })}
      >
        {" "}
      </div>
      {title && !showMenu && !showSidebar ? (
        <div
          className="Title"
          style={showSectionTitle ? { opacity: 1 } : { opacity: 0 }}
        >
          {title}
        </div>
      ) : (
        ""
      )}

      {state === "whatPatients" && !showMenu && !showSidebar ? (
        <button
          className="Reload"
          onClick={(_) => globalActor.send({ type: "SKIP_TO_START" })}
        >
          <span className="visually-hidden">Restart</span>
        </button>
      ) : (
        ""
      )}
      {state !== "start" &&
      state !== "disclaimer" &&
      state !== "place" &&
      !showSidebar ? (
        <button
          className="Burger"
          onClick={(_) => globalActor.send({ type: "TOGGLE_MENU" })}
        >
          <span className="visually-hidden">Toggle menu</span>
        </button>
      ) : (
        ""
      )}
    </header>
  );
}
